"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { jsx, jsxs } from "react/jsx-runtime";
import { aiSparkleIcon } from "../ui/icons";
import { cleanReferenceValue, splitReferences } from "../../helpers/references";
import { ManualPODMarkReasonCode } from "../data/types/Pb";
export const POD_CHECK_POSITIVE_LABELS = {
  [ManualPODMarkReasonCode.ManualPODMarkReasonCodeSignature]: "Signature present",
  [ManualPODMarkReasonCode.ManualPODMarkReasonCodeNoDamages]: "No damages",
  [ManualPODMarkReasonCode.ManualPODMarkReasonCodeNoCarrierRate]: "No carrier rate",
  [ManualPODMarkReasonCode.ManualPODMarkReasonCodeOneReferenceMatch]: "References match",
  [ManualPODMarkReasonCode.ManualPODMarkReasonCodeAllPagesPresent]: "All pages present",
  [ManualPODMarkReasonCode.ManualPODMarkReasonCodeIllegible]: "Legible",
  [ManualPODMarkReasonCode.ManualPODMarkReasonCodeOther]: "Other"
};
function getIndicatorIcon(indicator) {
  switch (indicator) {
    case "pass":
      return "\u2713";
    case "fail":
      return "\u2717";
    case "unknown":
      return "?";
    case "overridden":
      return "\u2013";
  }
}
function indicatorColorClass(indicator) {
  switch (indicator) {
    case "pass":
      return "pod-check-indicator--pass";
    case "fail":
      return "pod-check-indicator--fail";
    case "unknown":
      return "pod-check-indicator--unknown";
    case "overridden":
      return "pod-check-indicator--overridden";
  }
}
export function indicatorFromBoolean(value, passWhen = true) {
  if (value === passWhen) return { indicator: "pass", preChecked: true };
  if (value === !passWhen) return { indicator: "fail", preChecked: false };
  return { indicator: "unknown", preChecked: false };
}
function deriveSignatureCheck(document) {
  return __spreadValues({
    code: ManualPODMarkReasonCode.ManualPODMarkReasonCodeSignature,
    label: POD_CHECK_POSITIVE_LABELS[ManualPODMarkReasonCode.ManualPODMarkReasonCodeSignature]
  }, indicatorFromBoolean(document.is_signed));
}
function deriveDamageCheck(document) {
  return __spreadValues({
    code: ManualPODMarkReasonCode.ManualPODMarkReasonCodeNoDamages,
    label: POD_CHECK_POSITIVE_LABELS[ManualPODMarkReasonCode.ManualPODMarkReasonCodeNoDamages]
  }, indicatorFromBoolean(document.has_damage, false));
}
function deriveCarrierRateCheck(document) {
  return __spreadValues({
    code: ManualPODMarkReasonCode.ManualPODMarkReasonCodeNoCarrierRate,
    label: POD_CHECK_POSITIVE_LABELS[ManualPODMarkReasonCode.ManualPODMarkReasonCodeNoCarrierRate]
  }, indicatorFromBoolean(document.has_carrier_rate, false));
}
export function resolveMatchedDetails(matchedValues, loadReferences) {
  return matchedValues.map((value) => {
    const match = Object.entries(loadReferences).find(
      ([_, refValue]) => splitReferences(refValue).map((s) => cleanReferenceValue(s.trim())).includes(value)
    );
    return { label: match ? match[0] : "unknown key", value };
  });
}
function deriveBolValidationCheck(accountSettings, hasReferenceMatch, matchedReferenceValues, loadReferences) {
  if (!accountSettings.pod_requires_bol_validation) return null;
  const matchedDetails = matchedReferenceValues.length > 0 ? resolveMatchedDetails(matchedReferenceValues, loadReferences) : void 0;
  return __spreadProps(__spreadValues({
    code: ManualPODMarkReasonCode.ManualPODMarkReasonCodeOneReferenceMatch,
    label: "References match"
  }, indicatorFromBoolean(hasReferenceMatch)), {
    matchedDetails
  });
}
function deriveMultiPageCheck(accountSettings, document) {
  if (!accountSettings.enqueue_multi_page_bol_reviews) return null;
  return __spreadValues({
    code: ManualPODMarkReasonCode.ManualPODMarkReasonCodeAllPagesPresent,
    label: "All pages present"
  }, indicatorFromBoolean(document.has_missing_pages, false));
}
export function markAllOverridden(checks) {
  return checks.map((c) => __spreadProps(__spreadValues({}, c), {
    indicator: "overridden",
    preChecked: false,
    matchedDetails: void 0
  }));
}
export function deriveChecks(document, accountSettings, hasReferenceMatch, matchedReferenceValues = [], loadReferences = {}) {
  const checks = [
    deriveSignatureCheck(document),
    deriveDamageCheck(document),
    deriveCarrierRateCheck(document)
  ];
  const bolCheck = deriveBolValidationCheck(
    accountSettings,
    hasReferenceMatch,
    matchedReferenceValues,
    loadReferences
  );
  if (bolCheck) checks.push(bolCheck);
  const multiPageCheck = deriveMultiPageCheck(accountSettings, document);
  if (multiPageCheck) checks.push(multiPageCheck);
  return checks;
}
export function AutomationSection({ checks }) {
  return /* @__PURE__ */ jsxs("div", { className: "document-browser__pod-reason-section", children: [
    /* @__PURE__ */ jsxs("div", { className: "pod-check-automation-header", children: [
      aiSparkleIcon("currentColor"),
      /* @__PURE__ */ jsx("span", { children: "Automation:" })
    ] }),
    /* @__PURE__ */ jsx("div", { className: "document-browser__pod-reason-check-list", children: checks.map(({ code, label, indicator, matchedDetails }) => /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsxs(
        "div",
        {
          className: `document-browser__pod-reason-check-row ${indicatorColorClass(indicator)}`,
          children: [
            /* @__PURE__ */ jsx("span", { className: "pod-check-indicator", children: getIndicatorIcon(indicator) }),
            /* @__PURE__ */ jsx("span", { children: label })
          ]
        }
      ),
      matchedDetails && matchedDetails.length > 0 && /* @__PURE__ */ jsx("div", { className: "pod-check-matched-details v3__key-value-pairs", children: matchedDetails.map((detail, i) => [
        /* @__PURE__ */ jsx("span", { className: "v3__key-value-pairs-key", children: detail.label }, `k${i}`),
        /* @__PURE__ */ jsx("span", { className: "v3__key-value-pairs-value", children: detail.value }, `v${i}`)
      ]) })
    ] }, code)) })
  ] });
}
